module.exports = __webpack_public_path__ + "img/alert.01d3b5a5.svg";